import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Card,
  CardContent,
  CardMedia,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Button,
} from '@mui/material';

const Registration = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Conference Registration
        </Typography>

        <Grid container spacing={4}>
          {/* Registration Fee Details */}
          <Grid item xs={12}>
            <Paper sx={{ p: 4, mt: 2 }}>
              <Typography variant="h6" gutterBottom align="center">
                Registration Fee Details
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Registration category</TableCell>
                      <TableCell>PG Residents*</TableCell>
                      <TableCell>AROI member</TableCell>
                      <TableCell>Non-AROI member</TableCell>
                      <TableCell>Associate Delegates</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Regular registration (16th May to 31st October 2025)</TableCell>
                      <TableCell>₹2950</TableCell>
                      <TableCell>₹5900</TableCell>
                      <TableCell>₹7080</TableCell>
                      <TableCell>₹3540</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Spot Registration</TableCell>
                      <TableCell>₹3540</TableCell>
                      <TableCell>₹7080</TableCell>
                      <TableCell>₹8260</TableCell>
                      <TableCell>₹4720</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <Typography variant="caption" sx={{ display: 'block', mt: 2 }}>
                *PG Student – certificate by HOD with seal and ID card is mandatory
              </Typography>
            </Paper>
          </Grid>

          <Grid container item xs={12} spacing={4}>
            {/* Payment Details */}
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 4 }}>
                <Typography variant="h6" gutterBottom align="center">
                  Payment Details
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" paragraph>
                    <strong>Beneficiary Name:</strong> CMC Ludhiana Society
                  </Typography>
                  <Typography variant="body2" paragraph>
                    <strong>Name of Bank:</strong> HDFC Bank, The Mall road, Ludhiana
                  </Typography>
                  <Typography variant="body2" paragraph>
                    <strong>Account number:</strong> 99907999999990
                  </Typography>
                  <Typography variant="body2" paragraph>
                    <strong>IFSC code:</strong> HDFC0000034
                  </Typography>
                  <Typography variant="body2" paragraph>
                    <strong>MICR No.:</strong> 1412240002
                  </Typography>
                  <Typography variant="body2" paragraph>
                    <strong>SWIFT CODE:</strong> HDFCINBB
                  </Typography>
                  <Box sx={{ mt: 3, mb: 2, textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      href="https://pages.razorpay.com/nzaroi-nov2025"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        fontSize: '1.1rem',
                        fontWeight: 'bold',
                        py: 1.5,
                        px: 3,
                        borderRadius: 2,
                        textTransform: 'none',
                        boxShadow: 2,
                        '&:hover': {
                          boxShadow: 4,
                          transform: 'translateY(-2px)',
                        },
                      }}
                    >
                      Payment Link
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>

            {/* Google Form QR Code */}
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 4 }}>
                <Typography variant="h6" gutterBottom align="center">
                  Registration Form
                </Typography>
                <Typography variant="body1" paragraph align="center" color="text.secondary">
                  For registration, Scan the QR code or click on the below link
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Card sx={{ maxWidth: 300 }}>
                    <CardContent>
                      <CardMedia
                        component="img"
                        image="/registration-form-qr.png"
                        alt="Registration Form QR Code"
                        sx={{ width: '200px', height: '200px', margin: 'auto' }}
                      />
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
                        {/* Scan QR code to open registration form */}
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
                <Box sx={{ mt: 3, textAlign: 'center' }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    href="https://forms.gle/xCTR8BKASQE85ohc6"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      fontSize: '1rem',
                      py: 1,
                      px: 2,
                      borderRadius: 1,
                      textTransform: 'none',
                    }}
                  >
                    Registration Form Link
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Registration; 